module.exports = __webpack_public_path__ + "static/media/rewarded.6ea8c82e.png";